import React , { useState , useEffect } from 'react'
import Header from '../../components/Header/Header';
import AddIcon from '@mui/icons-material/Add';
import BorderColorIcon from '@mui/icons-material/BorderColor';
// import DeleteIcon from '@mui/icons-material/Delete';
import { getAllClientsData, searchClient } from '../../services/CommonService';
import CreateEditClientModal from '../../components/CreateEditClientModal/CreateEditClientModal';
import { CircularProgress } from '@mui/material';
import { Link, useNavigate } from 'react-router-dom';
import LinkIcon from '@mui/icons-material/Link';
// import DeleteClientModal from '../../components/DeleteClientModal/DeleteClientModal';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useClientDetailsContext } from '../../Context/ClientDetails';

const ClinicManagement = () => {
  const [ openCreateEditClientModal , setOpenCreateEditClientModal ] = useState(false);
  // const [ openDeleteClientModal , setOpenDeleteClientModal ] = useState(false);
  // const [ clientToDelete, setClientToDelete ] = useState(null);
  const [ editClientFlag , setEditClientFlag ] = useState(false);
  const [ dataToEdit , setDataToEdit ] = useState({});
  const [ loading , setLoading ] = useState(false);
  const [ refreshData , setRefreshData ] = useState(false);
  const [ searchInput , setSearchInput ] = useState('');
  const [ searchText , setSearchText ] = useState('');
  const [ showCopiedText , setShowCopiedText ] = useState("");
  const navigate = useNavigate();
  const { allClinicsData , setAllClinicsData } = useClientDetailsContext();

  useEffect(() => {
    if( allClinicsData?.length === 0 ){
      (() => {
        setLoading(true);
        getAllClientsData().then( res => {
          setAllClinicsData(res.clinics);
          setLoading(false);
        });
      })();
    }
  } , [ refreshData ]);

  const openCreateEditClientModalHandler = (editFlag , editData ) => {
    if(editFlag){
      setDataToEdit(editData);
    }
    setEditClientFlag(editFlag);
    setOpenCreateEditClientModal(true);
  }

  const clientSearchHandler = () => {
    setLoading(true);
    searchClient(searchInput).then( res => {
      console.log("searchData" , res);
      setAllClinicsData(res);
      setLoading(false);
    })
  }

  const refreshDataHandler = () => {
    setAllClinicsData([]);
    setRefreshData(!refreshData);
  };

  useEffect(() => {
    clientSearchHandler();
  } , [ searchText ]);

  useEffect(() => {
    const timer = setTimeout(() => {
      setSearchText(searchInput);
    }, 500);

    return () => clearTimeout(timer);
  } , [ searchInput ]);

  const copiedHandler = (link , id) => {
    setShowCopiedText(id);
    navigator.clipboard.writeText(link);
    setTimeout(() => setShowCopiedText("") , 2000);
  }

  // const openDeleteModal = (client) => {
  //   setClientToDelete(client);
  //   setOpenDeleteClientModal(true);
  // }

  return (
    <div className="max-w-[1440px] mx-auto my-0 bg-[#F5F9FF]">
      <Header />
      <div className="max-w-[1280px] min-h-[90vh] max-h-auto mx-auto my-0">
        <div className='flex pt-[1.5rem] pb-[2rem] cursor-pointer'>
          <div className='text-[1.4rem]' onClick={() => navigate("/")}><ArrowBackIcon /> Back </div>
        </div>
        <div className='flex justify-between items-center py-[2rem]'>
          <div className='text-[1.4rem] font-medium'>Client Information</div>
          <div className='flex gap-6'>
            <input type='search' placeholder='search' className='pl-[10px] border border-1 rounded-md focus:outline-none' value={searchInput} onChange={(e) => setSearchInput(e.target.value)} />
            <div className='bg-[#788CFC] text-[#fff] font-medium px-[1rem] py-[0.5rem] rounded-lg cursor-pointer' onClick={() => openCreateEditClientModalHandler(false)}> <AddIcon sx={{ color: "#fff" }} /> Add new Client</div>
          </div>
        </div>
        <div className='flex flex-col pb-[2rem]'>
          <div className='heading flex'>
            <div className='flex border-[#d3d3d3] flex-[0.2] bg-[#415280] text-[#fff] py-[12px] px-[24px]'>Sr.no</div>
            <div className='flex border-l-[0.2px] border-[#d3d3d3] flex-1 bg-[#415280] text-[#fff] py-[12px] px-[24px]'>Assessment Link</div>
            <div className='flex border-l-[0.2px] border-[#d3d3d3] flex-[0.5] bg-[#415280] text-[#fff] py-[12px] px-[24px]'>Client Name</div>
            <div className='flex border-l-[0.2px] border-[#d3d3d3] flex-[0.5] bg-[#415280] text-[#fff] py-[12px] px-[24px]'>No.of Active Users</div>
            <div className='flex border-l-[0.2px] border-[#d3d3d3] flex-[0.5] bg-[#415280] text-[#fff] py-[12px] px-[24px]'>No.of Assessments Taken</div>
            <div className='flex border-l-[0.2px] border-[#d3d3d3] flex-[0.4] bg-[#415280] text-[#fff] py-[12px] px-[24px]'>Actions Items</div>
          </div>
          {
            loading
            ? <div className='w-full my-[4rem] flex justify-center items-center'><CircularProgress size={50} /></div>
            : <div className='data flex flex-col bg-[#fff]'>
                {
                  allClinicsData && allClinicsData.length > 0
                  ? allClinicsData.map( ( client , index ) => (
                    <div className='flex' key={client.clinic_id}>
                      <div className='flex justify-start items-center font-medium border-b-[0.2px] border-[#d3d3d3] flex-[0.2] py-[1.1rem] px-[24px]'>{ index + 1 }.</div>
                      <div className='flex justify-start items-center font-medium border-l-[0.2px] border-b-[0.2px] border-[#d3d3d3] flex-1 py-[1.1rem] px-[24px] gap-4'>
                      <Link to={client?.clinic_assessment_link} target="_blank" rel="noopener noreferrer" className="text-[blue] underline">{client?.clinic_assessment_link}</Link>
                        <div className="bg-[#F5F9FF] border border-1 py-[4px] px-[6px] rounded-md cursor-pointer relative">
                          <div className="rotate-45" onClick={() => copiedHandler(client?.clinic_assessment_link, client.clinic_id)}><LinkIcon sx={{ color: '#000'}} /></div>
                          { showCopiedText === client.clinic_id && <div className="absolute bottom-[125%] left-[-65%]">
                            <div className="relative">
                              <div className="px-[1rem] py-[0.5rem] text-[#415280] rounded-md bg-[#E1EDFF]">Copied!</div>
                              <div className="w-[15px] h-[15px] bg-[#E1EDFF] rotate-45 absolute bottom-[-10%] left-[50%] translate-x-[-50%]"></div>
                            </div>
                          </div>}
                        </div>
                      </div>
                      <div className='flex justify-start items-center font-medium border-l-[0.2px] border-b-[0.2px] border-[#d3d3d3] flex-[0.5] py-[1.1rem] px-[24px]'>{ client.clinic_name || "" }</div>
                      <div className='flex justify-start items-center font-medium border-l-[0.2px] border-b-[0.2px] border-[#d3d3d3] flex-[0.5] py-[1.1rem] px-[24px]'>{ client.count_clinic_users || "0" }</div>
                      <div className='flex justify-start items-center font-medium border-l-[0.2px] border-b-[0.2px] border-[#d3d3d3] flex-[0.5] py-[1.1rem] px-[24px]'>{ client.count_clinic_assessments || "0" }</div>
                      <div className='flex justify-start items-center font-medium border-l-[0.2px] border-b-[0.2px] border-[#d3d3d3] flex-[0.4] py-[1.1rem] px-[24px] gap-4'>
                        <div className='px-[1.2rem] py-[0.4rem] rounded-md bg-[#415280] text-[#fff] font-medium cursor-pointer' onClick={() => openCreateEditClientModalHandler(true , client) }> <BorderColorIcon sx={{ color: "#fff" }} /> Edit</div>
                        {/* <div className='px-[1.2rem] py-[0.4rem] rounded-md bg-[#FF5C5C] text-[#fff] font-medium cursor-pointer' onClick={() => openDeleteModal(client) } > <DeleteIcon sx={{ color: "#fff" }} /> Delete </div> */}
                      </div>
                    </div>
                  ))
                  : <div className='w-full flex justify-center items-center py-[2rem] font-medium text-[1.2rem]'>No Clients Found</div>
                }
              </div>
          }
        </div>
      </div>
      <CreateEditClientModal open={openCreateEditClientModal} setOpen={setOpenCreateEditClientModal} isEdit={editClientFlag} dataToEdit={dataToEdit} refreshDataHandler={refreshDataHandler} />
      {/* <DeleteClientModal open={openDeleteClientModal} setOpen={setOpenDeleteClientModal} clientToDelete={clientToDelete} refreshDataHandler={refreshDataHandler} /> */}
    </div>
  )
}

export default ClinicManagement
